import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import ConfirmModal from '../../components/ConfirmModal';
import {api} from '../../api';


const TYPE_COLORS = {
  ASSET: 'bg-blue-100 text-blue-800',
  LIABILITY: 'bg-red-100 text-red-800',
  EQUITY: 'bg-purple-100 text-purple-800',
  REVENUE: 'bg-green-100 text-green-800',
  EXPENSE: 'bg-orange-100 text-orange-800',
};

export default function AccountDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [account, setAccount] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    api(`/accounts/${id}`).then(r => r.json()).then(setAccount);
  }, [id]);

  const handleDelete = async () => {
    await api(`/accounts/${id}`, { method: 'DELETE' });
    navigate('/accounting/accounts');
  };

  if (!account) return null;

  return (
    <Layout>
      <Link to="/accounting/accounts" className="text-emerald-600 hover:text-emerald-800 mb-4 inline-block">&larr; Back to Accounts</Link>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900">{account.code} — {account.name}</h1>
            </div>
            <div className="flex items-center gap-3">
              <span className={`px-4 py-2 rounded-full text-sm font-medium ${TYPE_COLORS[account.type] || 'bg-gray-100 text-gray-800'}`}>{account.type}</span>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${account.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                {account.active ? 'Active' : 'Inactive'}
              </span>
              <Link to={`/accounting/accounts/${id}/edit`} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Edit</Link>
              <button onClick={() => setDeleteModal(true)} className="px-4 py-2 border border-red-300 text-red-600 rounded-lg hover:bg-red-50">Delete</button>
            </div>
          </div>
        </div>
        <div className="p-4 md:p-6">
          <p className="text-sm text-gray-500 mb-1">Description</p>
          <p className="text-gray-900">{account.description || '—'}</p>
        </div>
      </div>

      <ConfirmModal open={deleteModal} title="Delete Account" message="Are you sure you want to delete this account?" onConfirm={handleDelete} onCancel={() => setDeleteModal(false)} />
    </Layout>
  );
}
